var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "content" },
    [
      _c("div", { staticClass: "head", on: { click: _vm.goOut } }, [
        _c("i", { staticClass: "el-icon-arrow-left go_icon" }),
        _c("div", [_vm._v("流程管理")]),
      ]),
      _c("div", { staticClass: "content_list" }, [
        _c("div", { staticClass: "nav_box" }, [
          _c("div", { staticClass: "nav_left" }, [
            _c(
              "div",
              { staticClass: "search_input" },
              [
                _c(
                  "el-input",
                  {
                    attrs: { placeholder: "请输入内容", clearable: "" },
                    on: { change: _vm.searchI },
                    model: {
                      value: _vm.queryInfo.query,
                      callback: function ($$v) {
                        _vm.$set(_vm.queryInfo, "query", $$v)
                      },
                      expression: "queryInfo.query",
                    },
                  },
                  [
                    _c("i", {
                      staticClass: "el-input__icon el-icon-search",
                      attrs: { slot: "prefix" },
                      on: { click: _vm.searchI },
                      slot: "prefix",
                    }),
                  ]
                ),
              ],
              1
            ),
          ]),
          _c(
            "div",
            { staticClass: "nav_left" },
            [
              _c("el-button", { on: { click: _vm.openDialog } }, [
                _c("i", {
                  staticClass: "iconfont icon-jiahao1 custom_icon",
                  staticStyle: { "font-size": "13px" },
                }),
                _vm._v(" 创建流程分类 "),
              ]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.openDialog1 } },
                [
                  _c("i", {
                    staticClass: "iconfont icon-jiahao1 custom_icon",
                    staticStyle: { color: "#ffffff" },
                  }),
                  _vm._v(" 创建流程 "),
                ]
              ),
            ],
            1
          ),
        ]),
        _vm.search_list
          ? _c("div", { staticClass: "data_list" }, [
              _vm.list.length > 0
                ? _c(
                    "div",
                    _vm._l(_vm.list, function (key, index1) {
                      return _c(
                        "el-row",
                        {
                          key: index1,
                          staticClass: "content_row",
                          nativeOn: {
                            click: function ($event) {
                              return _vm.openProcess(key)
                            },
                          },
                        },
                        [
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                effect: "dark",
                                content: key.flowName,
                                placement: "bottom",
                                "popper-class": "texttooltip",
                                "open-delay": 500,
                              },
                            },
                            [
                              _c(
                                "el-col",
                                {
                                  staticStyle: {
                                    overflow: "hidden",
                                    "text-overflow": "ellipsis",
                                    "white-space": "nowrap",
                                  },
                                  attrs: { span: 4 },
                                },
                                [_vm._v(_vm._s(key.flowName))]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 2 } },
                            [
                              key.status == 0
                                ? _c(
                                    "div",
                                    { staticStyle: { color: "#2db039" } },
                                    [_vm._v("正常")]
                                  )
                                : key.status == 1
                                ? _c(
                                    "el-tooltip",
                                    {
                                      attrs: {
                                        effect: "dark",
                                        "popper-class": "texttooltip",
                                        content:
                                          "停用后无法使用该流程创建新任务",
                                        placement: "top",
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticStyle: { color: "#dd483f" } },
                                        [_vm._v("停用")]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c("el-col", { attrs: { span: 4 } }, [
                            key.createUser && key.createUser.name
                              ? _c("div", { staticClass: "info_personnel1" }, [
                                  key.createUser.avatar != ""
                                    ? _c("img", {
                                        staticClass: "info_personnel_surname",
                                        attrs: { src: key.createUser.avatar },
                                      })
                                    : _c(
                                        "div",
                                        {
                                          staticClass: "info_personnel_surname",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              key.createUser.name.substring(
                                                0,
                                                1
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                  _vm.channel === "wechat"
                                    ? _c(
                                        "div",
                                        [
                                          _c("ww-open-data", {
                                            attrs: {
                                              type: "userName",
                                              openid: key.createUser.name,
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _c("div", [
                                        _vm._v(_vm._s(key.createUser.name)),
                                      ]),
                                ])
                              : _c("div", {
                                  staticStyle: {
                                    width: "10px",
                                    height: "24px",
                                  },
                                }),
                          ]),
                          _c(
                            "el-col",
                            { attrs: { span: 2 } },
                            [
                              key.activatFlag == 1
                                ? _c(
                                    "div",
                                    { staticStyle: { color: "#2db039" } },
                                    [_vm._v("已设置")]
                                  )
                                : key.activatFlag == 0
                                ? _c(
                                    "el-tooltip",
                                    {
                                      attrs: {
                                        effect: "dark",
                                        "popper-class": "texttooltip",
                                        content:
                                          "部分节点未设置执行人，无法使用该流程创建新任务",
                                        placement: "top",
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticStyle: { color: "#dd483f" } },
                                        [_vm._v("未设置")]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c("el-col", { attrs: { span: 7 } }, [
                            _vm._v(_vm._s(key.updateDate)),
                          ]),
                          _c("el-col", { attrs: { span: 5 } }, [
                            _c(
                              "div",
                              { staticClass: "content_btn" },
                              [
                                _c(
                                  "el-tooltip",
                                  {
                                    attrs: {
                                      effect: "dark",
                                      content: "配置",
                                      placement: "top",
                                      "popper-class": "texttooltip",
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "iconfont icon-shezhi icon_btn",
                                      staticStyle: { color: "#909090" },
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.openProcess(key)
                                        },
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "el-tooltip",
                                  {
                                    attrs: {
                                      effect: "dark",
                                      content: "编辑",
                                      placement: "top",
                                      "popper-class": "texttooltip",
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "iconfont icon-edit icon_btn",
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.openDialog2(key, index1)
                                        },
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "el-tooltip",
                                  {
                                    attrs: {
                                      effect: "dark",
                                      content: "复制",
                                      placement: "top",
                                      "popper-class": "texttooltip",
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "iconfont icon-fuzhi icon_btn",
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.openDialogCopy(
                                            key,
                                            key,
                                            index1
                                          )
                                        },
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "el-tooltip",
                                  {
                                    attrs: {
                                      effect: "dark",
                                      content: "权限设置",
                                      placement: "top",
                                      "popper-class": "texttooltip",
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "iconfont icon-quanxianshezhi icon_btn",
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.openDialog3(key, index1)
                                        },
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "el-tooltip",
                                  {
                                    attrs: {
                                      effect: "dark",
                                      content: "恢复",
                                      placement: "top",
                                      "popper-class": "texttooltip",
                                    },
                                  },
                                  [
                                    _c("i", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: key.status == 1,
                                          expression: "key.status == 1",
                                        },
                                      ],
                                      staticClass:
                                        "iconfont icon-ico_huifutuopushuju icon_btn",
                                      staticStyle: { "font-size": "15px" },
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.setUpFlowStatusDialog(
                                            key,
                                            index1
                                          )
                                        },
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "el-tooltip",
                                  {
                                    attrs: {
                                      effect: "dark",
                                      content: "停用",
                                      placement: "top",
                                      "popper-class": "texttooltip",
                                    },
                                  },
                                  [
                                    _c("i", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: key.status == 0,
                                          expression: "key.status == 0",
                                        },
                                      ],
                                      staticClass:
                                        "iconfont icon-zanting2 icon_btn",
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.setUpFlowStatusDialog(
                                            key,
                                            index1
                                          )
                                        },
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "el-tooltip",
                                  {
                                    attrs: {
                                      effect: "dark",
                                      content: "删除",
                                      placement: "top",
                                      "popper-class": "texttooltip",
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "iconfont icon-shanchu1 icon_btn",
                                      staticStyle: { "font-size": "15px" },
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.delFlowDialog(
                                            key,
                                            index1,
                                            ""
                                          )
                                        },
                                      },
                                    }),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]),
                        ],
                        1
                      )
                    }),
                    1
                  )
                : _c("div", [_c("noDate")], 1),
            ])
          : _c(
              "div",
              {
                staticStyle: {
                  flex: "1",
                  "overflow-y": "auto",
                  width: "calc(100% - -15px)",
                  height: "calc(100% - 92px)",
                },
                attrs: { "infinite-scroll-distance": "15" },
                on: { scroll: _vm.load },
              },
              [
                _c(
                  "el-collapse",
                  {
                    on: { change: _vm.handleChange },
                    model: {
                      value: _vm.queryInfo.activeName,
                      callback: function ($$v) {
                        _vm.$set(_vm.queryInfo, "activeName", $$v)
                      },
                      expression: "queryInfo.activeName",
                    },
                  },
                  _vm._l(_vm.processList, function (item, index) {
                    return _c(
                      "el-collapse-item",
                      {
                        key: index,
                        attrs: { name: item.id, "collapse-transition": false },
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "collapse-title",
                            attrs: { slot: "title" },
                            slot: "title",
                          },
                          [
                            _c("span", { staticClass: "collapse-title-name" }, [
                              _vm._v(" " + _vm._s(item.typeName) + " "),
                            ]),
                            _c("span", [
                              _vm._v("(" + _vm._s(item.flowCount) + ")"),
                            ]),
                            _vm.queryInfo.activeName == item.id && index > 0
                              ? _c("span", [
                                  _c("i", {
                                    staticClass: "iconfont icon-edit",
                                    staticStyle: {
                                      "margin-left": "23px",
                                      "margin-right": "17px",
                                    },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.openDialog4(item, index)
                                      },
                                    },
                                  }),
                                  _c("i", {
                                    staticClass: "iconfont icon-shanchu1",
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.delFlowTypeDialog(
                                          item,
                                          index
                                        )
                                      },
                                    },
                                  }),
                                ])
                              : _vm._e(),
                          ]
                        ),
                        _c("w-loading", {
                          ref: "loading",
                          refInFor: true,
                          attrs: { text: "加载中..", mask: true, click: true },
                        }),
                        item.List
                          ? _c(
                              "div",
                              {
                                staticClass: "content_box",
                                style: "height:" + item.List.length * 40 + "px",
                              },
                              _vm._l(item.List, function (key, index1) {
                                return _c(
                                  "el-row",
                                  {
                                    key: index1,
                                    staticClass: "content_row",
                                    nativeOn: {
                                      click: function ($event) {
                                        return _vm.openProcess(key)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "el-tooltip",
                                      {
                                        attrs: {
                                          effect: "dark",
                                          content: key.flowName,
                                          placement: "bottom",
                                          "popper-class": "texttooltip",
                                          "open-delay": 500,
                                        },
                                      },
                                      [
                                        _c(
                                          "el-col",
                                          {
                                            staticStyle: {
                                              overflow: "hidden",
                                              "text-overflow": "ellipsis",
                                              "white-space": "nowrap",
                                            },
                                            attrs: { span: 4 },
                                          },
                                          [_vm._v(_vm._s(key.flowName))]
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 2 } },
                                      [
                                        key.status == 0
                                          ? _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  color: "#2db039",
                                                },
                                              },
                                              [_vm._v("正常")]
                                            )
                                          : key.status == 1
                                          ? _c(
                                              "el-tooltip",
                                              {
                                                attrs: {
                                                  effect: "dark",
                                                  "popper-class": "texttooltip",
                                                  content:
                                                    "停用后无法使用该流程创建新任务",
                                                  placement: "top",
                                                },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      color: "#dd483f",
                                                    },
                                                  },
                                                  [_vm._v("停用")]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                    _c("el-col", { attrs: { span: 4 } }, [
                                      key.createUser && key.createUser.name
                                        ? _c(
                                            "div",
                                            { staticClass: "info_personnel1" },
                                            [
                                              key.createUser.avatar != ""
                                                ? _c("img", {
                                                    staticClass:
                                                      "info_personnel_surname",
                                                    attrs: {
                                                      src: key.createUser
                                                        .avatar,
                                                    },
                                                  })
                                                : _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "info_personnel_surname",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          key.createUser.name.substring(
                                                            0,
                                                            1
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                              _vm.channel === "wechat"
                                                ? _c(
                                                    "div",
                                                    [
                                                      _c("ww-open-data", {
                                                        attrs: {
                                                          type: "userName",
                                                          openid:
                                                            key.createUser.name,
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  )
                                                : _c("div", [
                                                    _vm._v(
                                                      _vm._s(
                                                        key.createUser.name
                                                      )
                                                    ),
                                                  ]),
                                            ]
                                          )
                                        : _c("div", {
                                            staticStyle: {
                                              width: "10px",
                                              height: "24px",
                                            },
                                          }),
                                    ]),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 2 } },
                                      [
                                        key.activatFlag == 1
                                          ? _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  color: "#2db039",
                                                },
                                              },
                                              [_vm._v("已设置")]
                                            )
                                          : key.activatFlag == 0
                                          ? _c(
                                              "el-tooltip",
                                              {
                                                attrs: {
                                                  effect: "dark",
                                                  "popper-class": "texttooltip",
                                                  content:
                                                    "部分节点未设置执行人，无法使用该流程创建新任务",
                                                  placement: "top",
                                                },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      color: "#dd483f",
                                                    },
                                                  },
                                                  [_vm._v("未设置")]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                    _c("el-col", { attrs: { span: 7 } }, [
                                      _vm._v(_vm._s(key.updateDate)),
                                    ]),
                                    _c("el-col", { attrs: { span: 5 } }, [
                                      _c(
                                        "div",
                                        { staticClass: "content_btn" },
                                        [
                                          _c(
                                            "el-tooltip",
                                            {
                                              attrs: {
                                                effect: "dark",
                                                content: "配置",
                                                placement: "top",
                                                "popper-class": "texttooltip",
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "iconfont icon-shezhi icon_btn",
                                                staticStyle: {
                                                  color: "#909090",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    $event.stopPropagation()
                                                    return _vm.openProcess(key)
                                                  },
                                                },
                                              }),
                                            ]
                                          ),
                                          _c(
                                            "el-tooltip",
                                            {
                                              attrs: {
                                                effect: "dark",
                                                content: "编辑",
                                                placement: "top",
                                                "popper-class": "texttooltip",
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "iconfont icon-edit icon_btn",
                                                on: {
                                                  click: function ($event) {
                                                    $event.stopPropagation()
                                                    return _vm.openDialog2(
                                                      key,
                                                      index1
                                                    )
                                                  },
                                                },
                                              }),
                                            ]
                                          ),
                                          _c(
                                            "el-tooltip",
                                            {
                                              attrs: {
                                                effect: "dark",
                                                content: "复制",
                                                placement: "top",
                                                "popper-class": "texttooltip",
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "iconfont icon-fuzhi icon_btn",
                                                on: {
                                                  click: function ($event) {
                                                    $event.stopPropagation()
                                                    return _vm.openDialogCopy(
                                                      item,
                                                      key,
                                                      index1
                                                    )
                                                  },
                                                },
                                              }),
                                            ]
                                          ),
                                          _c(
                                            "el-tooltip",
                                            {
                                              attrs: {
                                                effect: "dark",
                                                content: "权限设置",
                                                placement: "top",
                                                "popper-class": "texttooltip",
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "iconfont icon-quanxianshezhi icon_btn",
                                                on: {
                                                  click: function ($event) {
                                                    $event.stopPropagation()
                                                    return _vm.openDialog3(
                                                      key,
                                                      index1
                                                    )
                                                  },
                                                },
                                              }),
                                            ]
                                          ),
                                          _c(
                                            "el-tooltip",
                                            {
                                              attrs: {
                                                effect: "dark",
                                                content: "恢复",
                                                placement: "top",
                                                "popper-class": "texttooltip",
                                              },
                                            },
                                            [
                                              _c("i", {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value: key.status == 1,
                                                    expression:
                                                      "key.status == 1",
                                                  },
                                                ],
                                                staticClass:
                                                  "iconfont icon-ico_huifutuopushuju icon_btn",
                                                staticStyle: {
                                                  "font-size": "15px",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    $event.stopPropagation()
                                                    return _vm.setUpFlowStatusDialog(
                                                      key,
                                                      index1
                                                    )
                                                  },
                                                },
                                              }),
                                            ]
                                          ),
                                          _c(
                                            "el-tooltip",
                                            {
                                              attrs: {
                                                effect: "dark",
                                                content: "停用",
                                                placement: "top",
                                                "popper-class": "texttooltip",
                                              },
                                            },
                                            [
                                              _c("i", {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value: key.status == 0,
                                                    expression:
                                                      "key.status == 0",
                                                  },
                                                ],
                                                staticClass:
                                                  "iconfont icon-zanting2 icon_btn",
                                                on: {
                                                  click: function ($event) {
                                                    $event.stopPropagation()
                                                    return _vm.setUpFlowStatusDialog(
                                                      key,
                                                      index1
                                                    )
                                                  },
                                                },
                                              }),
                                            ]
                                          ),
                                          _c(
                                            "el-tooltip",
                                            {
                                              attrs: {
                                                effect: "dark",
                                                content: "删除",
                                                placement: "top",
                                                "popper-class": "texttooltip",
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "iconfont icon-shanchu1 icon_btn",
                                                staticStyle: {
                                                  "font-size": "15px",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    $event.stopPropagation()
                                                    return _vm.delFlowDialog(
                                                      key,
                                                      index1,
                                                      index
                                                    )
                                                  },
                                                },
                                              }),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]),
                                  ],
                                  1
                                )
                              }),
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    )
                  }),
                  1
                ),
              ],
              1
            ),
      ]),
      _c("Dialogs", {
        attrs: { dialogs: _vm.dialog },
        on: { dialogVisible: _vm.beforeClose },
        scopedSlots: _vm._u([
          {
            key: "desc",
            fn: function () {
              return [
                _c("div", { staticClass: "cover_boxs" }, [
                  _c(
                    "div",
                    { staticClass: "info_subject" },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          placeholder: "请输入流程分类名称",
                          autosize: { minRows: 1, maxRows: 5 },
                          maxlength: "200",
                          "show-word-limit": "",
                        },
                        model: {
                          value: _vm.dialog.typeName,
                          callback: function ($$v) {
                            _vm.$set(_vm.dialog, "typeName", $$v)
                          },
                          expression: "dialog.typeName",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("Dialogs", {
        attrs: { dialogs: _vm.dialog1 },
        on: { dialogVisible: _vm.beforeClose },
        scopedSlots: _vm._u([
          {
            key: "desc",
            fn: function () {
              return [
                _c("div", { staticClass: "cover_boxs" }, [
                  _c(
                    "div",
                    { staticClass: "info_subject" },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          placeholder: "请输入流程名称，200字以内",
                          autosize: { minRows: 1, maxRows: 5 },
                          maxlength: "200",
                          "show-word-limit": "",
                        },
                        model: {
                          value: _vm.dialog1.flowName,
                          callback: function ($$v) {
                            _vm.$set(_vm.dialog1, "flowName", $$v)
                          },
                          expression: "dialog1.flowName",
                        },
                      }),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "create_box" }, [
                    _c("div", { staticClass: "create_key" }, [
                      _c("i", {
                        staticClass: "iconfont icon-type create_icon",
                      }),
                      _c("div", [_vm._v("流程分类")]),
                    ]),
                    _c(
                      "div",
                      { staticClass: "create_value" },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: { placeholder: "请选择", filterable: "" },
                            model: {
                              value: _vm.dialog1.typeId,
                              callback: function ($$v) {
                                _vm.$set(_vm.dialog1, "typeId", $$v)
                              },
                              expression: "dialog1.typeId",
                            },
                          },
                          _vm._l(_vm.processLists, function (item) {
                            return _c("el-option", {
                              key: item.id,
                              attrs: { label: item.typeName, value: item.id },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("Dialogs", {
        attrs: { dialogs: _vm.dialog2 },
        on: { dialogVisible: _vm.beforeClose },
        scopedSlots: _vm._u([
          {
            key: "desc",
            fn: function () {
              return [
                _c("div", { staticClass: "cover_boxs" }, [
                  _c(
                    "div",
                    { staticClass: "info_subject" },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          placeholder: "请输入流程分类名称",
                          autosize: { minRows: 1, maxRows: 5 },
                          maxlength: "200",
                          "show-word-limit": "",
                        },
                        model: {
                          value: _vm.dialog2.flowName,
                          callback: function ($$v) {
                            _vm.$set(_vm.dialog2, "flowName", $$v)
                          },
                          expression: "dialog2.flowName",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _c("div", { staticClass: "create_box" }, [
                  _c("div", { staticClass: "create_key" }, [
                    _c("i", { staticClass: "iconfont icon-type create_icon" }),
                    _c("div", [_vm._v("流程分类")]),
                  ]),
                  _c(
                    "div",
                    { staticClass: "create_value" },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "请选择", filterable: "" },
                          on: { change: _vm.pcmFormTypeChange },
                          model: {
                            value: _vm.dialog2.typeIds,
                            callback: function ($$v) {
                              _vm.$set(_vm.dialog2, "typeIds", $$v)
                            },
                            expression: "dialog2.typeIds",
                          },
                        },
                        _vm._l(_vm.processLists, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.typeName, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("Dialogs", {
        attrs: { dialogs: _vm.dialog3 },
        on: { dialogVisible: _vm.beforeClose },
        scopedSlots: _vm._u([
          {
            key: "desc",
            fn: function () {
              return [
                _c(
                  "div",
                  {
                    staticClass: "permissions_box",
                    staticStyle: { height: "60px" },
                  },
                  [
                    _c("div", [
                      _c(
                        "div",
                        { staticClass: "permissions_label" },
                        [
                          _vm._v("修改权限 "),
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                effect: "dark",
                                "popper-class": "texttooltip",
                                placement: "right",
                              },
                            },
                            [
                              _c(
                                "div",
                                { attrs: { slot: "content" }, slot: "content" },
                                [_vm._v("发起流程任务后，是否支持修改任务信息")]
                              ),
                              _c("i", {
                                staticClass:
                                  "iconfont icon-shuoming progress_icon",
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "permissions_value" },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.permissions.taskEditFlag,
                                callback: function ($$v) {
                                  _vm.$set(_vm.permissions, "taskEditFlag", $$v)
                                },
                                expression: "permissions.taskEditFlag",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: "0" } }, [
                                _vm._v("支持修改"),
                              ]),
                              _c("el-radio", { attrs: { label: "1" } }, [
                                _vm._v("不支持修改"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]),
                  ]
                ),
                _c("div", { staticClass: "permissions_box" }, [
                  _c("div", [
                    _c("div", { staticClass: "permissions_label" }, [
                      _vm._v("可见范围"),
                    ]),
                    _c(
                      "div",
                      { staticClass: "permissions_value" },
                      [
                        _c(
                          "el-radio-group",
                          {
                            model: {
                              value: _vm.permissions.authType,
                              callback: function ($$v) {
                                _vm.$set(_vm.permissions, "authType", $$v)
                              },
                              expression: "permissions.authType",
                            },
                          },
                          [
                            _c("el-radio", { attrs: { label: "0" } }, [
                              _vm._v("全部项目成员可见"),
                            ]),
                            _c("el-radio", { attrs: { label: "1" } }, [
                              _vm._v("部分项目成员可见"),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.permissions.authType == 1,
                          expression: "permissions.authType == 1",
                        },
                      ],
                    },
                    [
                      _c("div", { staticClass: "permissions_label" }, [
                        _vm._v("可见成员"),
                      ]),
                      _c(
                        "div",
                        { staticClass: "users_personnel" },
                        [
                          _vm._l(
                            _vm.permissions.authUserList,
                            function (item, index) {
                              return _c(
                                "div",
                                { key: index, staticClass: "user_personnel" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "info_personnel",
                                      on: {
                                        click: function ($event) {
                                          return _vm.contactCh(
                                            _vm.permissions.authUserList
                                          )
                                        },
                                      },
                                    },
                                    [
                                      item.avatar != "" && item.avatar !== null
                                        ? _c("img", {
                                            staticClass:
                                              "info_personnel_surname",
                                            attrs: { src: item.avatar },
                                          })
                                        : _c(
                                            "div",
                                            {
                                              staticClass:
                                                "info_personnel_surname",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  item.name.substring(0, 1)
                                                )
                                              ),
                                            ]
                                          ),
                                      _vm.channel === "wechat"
                                        ? _c(
                                            "div",
                                            [
                                              _c("ww-open-data", {
                                                attrs: {
                                                  type: "userName",
                                                  openid: item.name,
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        : _c("div", [
                                            _vm._v(_vm._s(item.name)),
                                          ]),
                                    ]
                                  ),
                                  _c("i", {
                                    staticClass:
                                      "iconfont icon-shanchu del_icon",
                                    on: {
                                      click: function ($event) {
                                        return _vm.delUsers(
                                          _vm.permissions.authUserList,
                                          index
                                        )
                                      },
                                    },
                                  }),
                                ]
                              )
                            }
                          ),
                          _c("i", {
                            staticClass: "iconfont icon-jiahao2fill add_icon",
                            style:
                              _vm.permissions.authUserList.length > 0
                                ? "margin-left:34px"
                                : "",
                            on: {
                              click: function ($event) {
                                return _vm.contactCh(
                                  _vm.permissions.authUserList
                                )
                              },
                            },
                          }),
                        ],
                        2
                      ),
                    ]
                  ),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("Dialogs", {
        attrs: { dialogs: _vm.dialog4 },
        on: { dialogVisible: _vm.beforeClose },
        scopedSlots: _vm._u([
          {
            key: "desc",
            fn: function () {
              return [
                _c("div", { staticClass: "cover_boxs" }, [
                  _c(
                    "div",
                    { staticClass: "info_subject" },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          placeholder: "请输入流程分类名称",
                          autosize: { minRows: 1, maxRows: 5 },
                          maxlength: "200",
                          "show-word-limit": "",
                        },
                        model: {
                          value: _vm.dialog4.typeName,
                          callback: function ($$v) {
                            _vm.$set(_vm.dialog4, "typeName", $$v)
                          },
                          expression: "dialog4.typeName",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("Dialogs", {
        attrs: { dialogs: _vm.dialogCopy },
        on: { dialogVisible: _vm.beforeClose },
        scopedSlots: _vm._u([
          {
            key: "desc",
            fn: function () {
              return [
                _c("div", { staticClass: "cover_boxs" }, [
                  _c(
                    "div",
                    { staticClass: "info_subject" },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          placeholder: "请输入流程分类名称",
                          autosize: { minRows: 1, maxRows: 5 },
                          maxlength: "200",
                          "show-word-limit": "",
                        },
                        model: {
                          value: _vm.dialogCopy.flowName,
                          callback: function ($$v) {
                            _vm.$set(_vm.dialogCopy, "flowName", $$v)
                          },
                          expression: "dialogCopy.flowName",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _c("div", { staticClass: "create_box" }, [
                  _c("div", { staticClass: "create_key" }, [
                    _c("i", { staticClass: "iconfont icon-type create_icon" }),
                    _c("div", [_vm._v("流程分类")]),
                  ]),
                  _c(
                    "div",
                    { staticClass: "create_value" },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "请选择", filterable: "" },
                          on: { change: _vm.pcmFormTypeChange },
                          model: {
                            value: _vm.dialogCopy.typeIds,
                            callback: function ($$v) {
                              _vm.$set(_vm.dialogCopy, "typeIds", $$v)
                            },
                            expression: "dialogCopy.typeIds",
                          },
                        },
                        _vm._l(_vm.processLists, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.typeName, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("selectingpeo", {
        ref: "selectingPeo",
        on: { chooseUserFlag: _vm.taskFollow },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }